module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(0), (_vm.showTryAgain) ? _c('div', {
    staticClass: "try-again"
  }, [_c('div', {
    staticClass: "try-again__link"
  }, [_c('button', {
    staticClass: "w-button w-button--link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('reset')
      }
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Try again")])])]), (_vm.inAppLogin) ? _c('div', {
    staticClass: "try-again__link"
  }, [_c('button', {
    staticClass: "w-button w-button--link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Cancel")])])]) : _vm._e()]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-preloader"
  }, [_c('div', {
    staticClass: "w-preloader__spinner--large"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6080515a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Loading/Loading.vue
// module id = 600
// module chunks = 1